<template>
    <div>
        <h5 :class="{ hidden: alwaysShow || (selection == 1) }">
            Seleziona solo una riga, per visualizzare dettagli.
        </h5>
        <div v-cloak ref="panel" :class="{ hidden: !alwaysShow && (selection != 1) }">
            <ul class="nav nav-tabs" role="tablist">
                <slot name="header" />
            </ul>
            <div class="tab-content">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
'use strict';

class LowerPanelController {
    constructor(panelObject) {
        this._tabs = {};
        this._tabsState = {};
        this._tab = null;
        this._prevSelected = null;
        this._selected = null;
        this._panelObject = panelObject;
        $(panelObject).on('shown.bs.tab', 'a[data-toggle="tab"]', () => {
            this.updateInfo();
        });
    }

    selectionChanged(selected) {
        this._selected = selected;
        this.updateInfo();
    }

    addTab(name, tab) {
        this._tabs[name] = tab;
    }

    updateInfo(force) {
        if(!this._selected || (this._selected.length != 1))
            return;
        if(force || (this._selected !== this._prevSelected)) {
            this._prevSelected = this._selected;
            this._tabsState = {};
            this._tab = null;
        }
        const tab = $(this._panelObject).find('li.active').attr('id');
        if(!tab)
            return;
        if(!this._tabsState[tab]) {
            const handler = this._tabs[tab];
            if(handler)
                handler(this._selected[0]);
            this._tabsState[tab] = true;
        }
    }
}

export default {
    props: {
        // eslint-disable-next-line vue/require-default-prop
        selected: Array,
        alwaysShow: Boolean,
    },
    data() {
        return {
            suspended: false,
            controller: undefined,
            panel: undefined,
        };
    },
    computed: {
        selection() {
            return this.selected.length;
        },
    },
    watch: {
        selected(newVal) {
            if(!this.suspended)
                this.controller.selectionChanged(newVal);
        },
    },
    mounted() {
        Object.defineProperty(this, 'panel', { value: this.$refs.panel, writable: false });
        Object.defineProperty(this, 'controller', { value: new LowerPanelController(this.panel), writable: false });
        this.controller.selectionChanged(this.selected);
    },
    methods: {
        addTab(name, tab) {
            this.controller.addTab(name, tab);
        },
        switchToTab(name) {
            $('#' + name).find('a').tab('show');
        },
        suspend(suspended) {
            this.suspended = suspended;
            if(!suspended)
                this.controller.selectionChanged(this.selected);
        },
    },
};


</script>
